import http from 'plugins/axios';

export default {
  getAllCoin() {
    return http.get({
      url: '/la/admin/pair/list'
    });
  },
  getList(data) {
    return http.get({
      url: '/la/admin/trade/deal',
      data
    });
  }
};
